/**
 * @generated SignedSource<<01e37cd83f654cf2b11cb22e291a3908>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type BuildTestsTabCountsQuery$variables = {
  locator: string;
};
export type BuildTestsTabCountsQuery$data = {
  readonly testOccurrences: {
    readonly testCounters: {
      readonly " $fragmentSpreads": FragmentRefs<"TestScopesViewCountsFragment" | "TestsFilterCountsFragment">;
    } | null | undefined;
  } | null | undefined;
};
export type BuildTestsTabCountsQuery = {
  response: BuildTestsTabCountsQuery$data;
  variables: BuildTestsTabCountsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "locator"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "locator",
    "variableName": "locator"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "BuildTestsTabCountsQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "TestOccurrences",
        "kind": "LinkedField",
        "name": "testOccurrences",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "TestCounters",
            "kind": "LinkedField",
            "name": "testCounters",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "TestScopesViewCountsFragment"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "TestsFilterCountsFragment"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "BuildTestsTabCountsQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "TestOccurrences",
        "kind": "LinkedField",
        "name": "testOccurrences",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "TestCounters",
            "kind": "LinkedField",
            "name": "testCounters",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "success",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "failed",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "muted",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "ignored",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "all",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "newFailed",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "duration",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "00be51f2ba54f0f792cc323c0119f68e",
    "id": null,
    "metadata": {},
    "name": "BuildTestsTabCountsQuery",
    "operationKind": "query",
    "text": "query BuildTestsTabCountsQuery(\n  $locator: String!\n) {\n  testOccurrences(locator: $locator) {\n    testCounters {\n      ...TestScopesViewCountsFragment\n      ...TestsFilterCountsFragment\n    }\n  }\n}\n\nfragment TestScopesViewCountsFragment on TestCounters {\n  success\n  failed\n  muted\n  ignored\n}\n\nfragment TestsFilterCountsFragment on TestCounters {\n  all\n  ignored\n  success\n  muted\n  failed\n  newFailed\n  duration\n}\n"
  }
};
})();

(node as any).hash = "660ac9c8a88dfdce47c3fdd7989da902";

export default node;
